import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=232a74d6"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports